import { TemplateElement, html, defineElement, when, classMap } from '@webtides/element-js';
import style from './testimonial.css';
import { responsiveImage } from '../../../../directives/images.js';

/**
 * Testimonial component displaying a quote with author information and image
 * @property {'default' | 'highlight'} variant - Variant to be used
 * @property {string} quote - The testimonial quote text
 * @property {string} authorName - Name of the quote author
 * @property {string} authorTitle - Title or position of the author
 * @property {ImageProperties} authorImage - Author's profile image
 */
export default class Testimonial extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            variant: 'default',
            quote: '',
            authorName: '',
            authorTitle: '',
            authorImage: null,
        };
    }

    template() {
        const wrapperClasses = {
            'border-l-4 border-l-primary pl-20': this.variant === 'highlight',
        };
        const quoteClasses = {
            'items-center text-center': this.variant === 'default',
            'py-8': this.variant === 'highlight',
        };
        const authorClasses = {
            'flex-col': this.variant === 'default',
            'flex-row': this.variant === 'highlight',
        };
        return html`
            <div class="${classMap(wrapperClasses)}">
                <blockquote class="flex flex-col gap-32 m-0 text-green-medium ${classMap(quoteClasses)}">
                    <p
                        class="flex-headline3-medium text-green-medium text-balance mb-0"
                    >
                        <span aria-hidden="true">${this.variant === 'default' ? '“' : '«'}</span>
                        ${this.quote}
                        <span aria-hidden="true">${this.variant === 'default' ? '“' : '»'}</span>
                    </p>
                    <div class="flex items-center gap-12 ${classMap(authorClasses)}">
                        ${when(
                            this.authorImage?.srcset,
                            html`
                                ${responsiveImage(this.authorImage, 'object-cover size-40 rounded-full', false, 'auto', '40px')}
                            `,
                        )}
                        ${when(
                            this.authorName,
                            html`
                                <div>
                                    <cite class="fix-body3-medium md:fix-body1-bold text-green-medium">
                                        ${this.authorName}
                                    </cite>
                                    <div class="fix-body3 md:fix-body1 text-green-light">${this.authorTitle}</div>
                                </div>
                            `,
                        )}
                    </div>
                </blockquote>
            </div>
        `;
    }
}

defineElement('mb-testimonial', Testimonial);
